import { useMutation } from '@tanstack/react-query';
import { shipmentService, type QuoteRequest, type QuoteResponse } from '../../services/shipment.service';

export const useQuoteMutation = () => {
    return useMutation<QuoteResponse, Error, QuoteRequest>({
        mutationFn: (data: QuoteRequest) => shipmentService.getQuote(data),
    });
};
